import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  TextField
} from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  readOnly = false,
  connectionType = "baileys"
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editedBody, setEditedBody] = useState("");
  const [savingEdit, setSavingEdit] = useState(false);

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleOpenEditModal = () => {
    setEditedBody(String(message.body || ""));
    setEditOpen(true);
    handleClose();
  };

  const handleEditMessage = async () => {
    const body = String(editedBody || "").trim();
    if (!body || body === String(message.body || "").trim()) return;

    setSavingEdit(true);
    try {
      await api.put(`/messages/${message.id}`, { body });
      setEditOpen(false);
    } catch (err) {
      toastError(err);
    } finally {
      setSavingEdit(false);
    }
  };

  const localOnlyMessage = message.mediaType === "internal_comment";
  const supportedChannel = ["baileys", "webchat"].includes(
    String(connectionType || "baileys")
  );
  const canEdit =
    message.fromMe &&
    !message.isDeleted &&
    !readOnly &&
    (supportedChannel || localOnlyMessage) &&
    ["chat", "internal_comment"].includes(String(message.mediaType || "chat"));
  const canDelete =
    message.fromMe &&
    !message.isDeleted &&
    !readOnly &&
    (supportedChannel || localOnlyMessage);

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{i18n.t("messageOptionsMenu.editTitle")}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            value={editedBody}
            onChange={event => setEditedBody(event.target.value)}
            disabled={savingEdit}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditOpen(false)} disabled={savingEdit}>
            {i18n.t("messageOptionsMenu.cancel")}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleEditMessage}
            disabled={
              savingEdit ||
              !String(editedBody || "").trim() ||
              String(editedBody || "").trim() === String(message.body || "").trim()
            }
          >
            {i18n.t("messageOptionsMenu.save")}
          </Button>
        </DialogActions>
      </Dialog>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {canEdit && (
          <MenuItem onClick={handleOpenEditModal}>
            {i18n.t("messageOptionsMenu.edit")}
          </MenuItem>
        )}
        {canDelete && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        {!readOnly && (
          <MenuItem onClick={hanldeReplyMessage}>
            {i18n.t("messageOptionsMenu.reply")}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
